import { getChromeRuntime } from './wrappers';

/**
 * get the version defined in the extension manifest
 */
export const getExtensionVersion = (): string => {
  return getChromeRuntime().getManifest().version || '0';
};

/**
 * get information about the current platform.
 */
export const getPlatformInfo = async (): Promise<{
  arch: string;
  nacl_arch: string;
  os: string;
}> =>
  new Promise(resolve => {
    getChromeRuntime().getPlatformInfo(platformInfo => resolve(platformInfo));
  });
